import Cities from "./Searchbar-Cities";

const Holder = ({
  isHovering,
  handleMouseOver,
  handleMouseOut,
  cityNames,
  alphabet,
}) => {
  return (
    <>
      <div
        onMouseOver={() => handleMouseOver(alphabet)}
        className="bg-white hover:bg-[black] hover:text-white font-semibold hover:bg-opacity-80 text-black  py-1 w-full text-center "
      >
        {alphabet}
      </div>

      {/*  */}
    </>
  );
};

export default Holder;
